export function padLeadingZero(value) {
  return value > 9 ? value : `0${value}`;
}

export function getFormattedDateTime(date = new Date()) {
  return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${padLeadingZero(date.getMinutes())}:${padLeadingZero(date.getSeconds())}`;
}

export function getMonday(date) {
  const mondayDay = new Date(date);
  const day = mondayDay.getDay();
  const diff = mondayDay.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(mondayDay.setDate(diff));
}
export function getSunday(date) {
  const sundayDay = new Date(date);
  sundayDay.setDate(getMonday(date).getDate() + 6);
  return sundayDay;
}
